import React from "react";

export const SearchOptionsContext = React.createContext();